"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var is_number_1 = require("./is-number");
var isPositive = function (num) {
    return is_number_1.default(num) && num > 0;
};
exports.default = isPositive;
//# sourceMappingURL=is-positive.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/is-positive.js
// module id = 1125
// module chunks = 37